export const BRANCH_LIST = {
  url: '/v1/branch',
  method: 'GET',
  reducerKey: 'branches',
  isPaginated: false,
};

export const BRAND_LIST = {
  url: '/v1/brand',
  method: 'GET',
  reducerKey: 'brands',
  isPaginated: false,
};

export const CATEGORY_LIST = {
  url: '/v1/menu-v2/store/categories',
  method: 'GET',
  reducerKey: 'categories',
  isPaginated: false,
};

export const GET_BRAND_PROFILE_ROUTING = {
  url: '/v1/printer/v2/settings/%s/brand/%s',
  method: 'GET',
  loaderKey: 'isLoading',
};

export const ITEM_LIST = {
  url: '/v1/menu-v2/store/items',
  method: 'GET',
  reducerKey: 'items',
  isPaginated: false,
};

export const PRINTER_PROFILES = {
  url: '/v1/printer/settings/%s',
  method: 'GET',
  isPaginated: false,
  loaderKey: 'isLoadingProfiles',
};

export const PRINTER_PROFILE_SAVE = {
  url: '/v1/printer/v2/settings',
  method: 'POST',
  loaderKey: 'isSaving',
};

export const SAVE_BRAND_PROFILE_ROUTING = {
  url: '/v1/printer/v2/settings/%s',
  method: 'PATCH',
  loaderKey: 'isSaving',
};
